
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-benefits",
      function () {
        return require("private-next-pages/student-benefits/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student-benefits"])
      });
    }
  